import { feiertagsregion } from "@mrmachine/fach";
import type { Bundesland, Randregel } from "@mrmachine/fach";
import { vorabendJeTag } from "./vorabend";

type Betriebswerte = { wetterOrt?: string; stundenJeTag?: number; feiertagsland?: Bundesland; abholung?: Randregel };

/**
 * Wetterort und Stunden je Tag aus `GET /ich` (A-01). Heute und Planung
 * brauchen sie auch für den, der `GET /einstellungen` nicht lesen darf.
 */
export function betriebswerteAusIch(
  e: Record<string, unknown> | null | undefined,
): Betriebswerte {
  if (!e) return {};
  const aus: Betriebswerte = {};
  if (typeof e["weather_location"] === "string") aus.wetterOrt = e["weather_location"];
  const std = Number(e["planned_hours_per_day"]);
  if (e["planned_hours_per_day"] != null && Number.isFinite(std) && std > 0) aus.stundenJeTag = std;
  /* Das Land für den Feiertagshinweis (0287): eingestellt, sonst aus der
     Postleitzahl der Anschrift, sonst Niedersachsen. Nur Anzeige. Ohne
     beides in der Antwort (eine API vor 0287) bleibt es weg — der Haken
     nimmt dann die Vorgabe. */
  /* Die Abholzeiten (0286/0288) für den Hinweis beim Vermieten — nur der
     Vorabend; der Morgen spielt dort keine Rolle. */
  if ("early_pickup_from" in e) {
    const ab = typeof e["early_pickup_from"] === "string" ? e["early_pickup_from"].slice(0, 5) : null;
    aus.abholung = { vorabend_ab: ab || null, morgen_bis: null, vorabend_je_tag: vorabendJeTag(e["early_pickup_by_weekday"]) };
  }
  if (!("holiday_region" in e) && !("address" in e)) return aus;
  const anschrift = e["address"];
  const plz = anschrift && typeof anschrift === "object" && !Array.isArray(anschrift)
    ? (anschrift as Record<string, unknown>)["plz"] : null;
  aus.feiertagsland = feiertagsregion(
    typeof e["holiday_region"] === "string" ? e["holiday_region"] : null,
    typeof plz === "string" ? plz : null,
  );
  return aus;
}
